import PropTypes from 'prop-types';
import TextFormField from './IntegrationTextFormField';
import CheckboxFormField from './IntegrationCheckboxFormField';
import Row from './IntegrationFormRow';

PunchoutIntegration.propTypes = {
  value: PropTypes.object,
  setValue: PropTypes.func
};

export default function PunchoutIntegration({ value, setValue }) {

  return <>
    <TextFormField
      header={"Start Punchout URL"}
      value={value.startPunchoutURL}
      onChange={(e) => setValue({ ...value, startPunchoutURL: e.target.value })}
    />
    <TextFormField
      header={"Return Punchout URL"}
      value={value.returnPunchoutURL}
      onChange={(e) => setValue({ ...value, returnPunchoutURL: e.target.value })}
    />
    <TextFormField
      header={"Append To Vendor Identity"}
      value={value.appendToVendorIdentity}
      onChange={(e) => setValue({ ...value, appendToVendorIdentity: e.target.value })}
    />  
    <Row>
      <TextFormField
        header={'PS Identity'}
        value={value.psIdentity}
        onChange={(e) => setValue({ ...value, psIdentity: e.target.value })}
      />
      <TextFormField
        header={'Vendor Identity'}
        value={value.vendorIdentity}
        onChange={(e) => setValue({ ...value, vendorIdentity: e.target.value })}
      />
      <TextFormField
        header={'Sender Identity'}
        value={value.senderIdentity}
        onChange={(e) => setValue({ ...value, senderIdentity: e.target.value })}
      />
    </Row>
    <Row>
      <TextFormField
        header={'PS Identity Domain'}
        value={value.psIdentityDomain}
        onChange={(e) => setValue({ ...value, psIdentityDomain: e.target.value })}
      />
      <TextFormField
        header={'Vendor Identity Domain'}
        value={value.vendorIdentityDomain}
        onChange={(e) => setValue({ ...value, vendorIdentityDomain: e.target.value })}
      />
      <TextFormField
        header={'Sender Identity Domain'}
        value={value.senderIdentityDomain}
        onChange={(e) => setValue({ ...value, senderIdentityDomain: e.target.value })}
      />
    </Row>
    <Row>
      <CheckboxFormField
        label={"Disabled"}
        checked={value.disabled ?? false}
        onChange={(e) => setValue({ ...value, disabled: e.target.checked })}
      />
      <CheckboxFormField
        label={"Extrinsic Unique Name"}
        checked={value.extrinsicUniqueName ?? false}
        onChange={(e) => setValue({ ...value, extrinsicUniqueName: e.target.checked })}
      />
      <CheckboxFormField
        label={"Allows Order Changes"}
        checked={value.allowsOrderChanges ?? false}
        onChange={(e) => setValue({ ...value, allowsOrderChanges: e.target.checked })}
      />
    </Row>
    <CheckboxFormField
      label={"Use Account As Vendor Identity"}
      checked={value.useAccountAsVendorIdentity ?? false}
      onChange={(e) => setValue({ ...value, useAccountAsVendorIdentity: e.target.checked })}
    />     
  </>;
}
